import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isObject } from '@philips-internal/oswald-ui-utils';
const UNIQUE = 'unique';
function UniqueValidator(values, options = {}) {
    let valid = true;
    if (!Array.isArray(values)) {
        return [{
                message: MessageService.translate('tws.validator.unique'),
                name: UNIQUE,
                valid,
            }];
    }
    const duplicateChecking = new Set();
    for (const value of values) {
        let key;
        if (isObject(value) && options.primaryKey) {
            key = String(value[options.primaryKey]);
        }
        else {
            key = value;
        }
        if (duplicateChecking.has(key)) {
            valid = false;
            break;
        }
        duplicateChecking.add(key);
    }
    return [{
            message: MessageService.translate('tws.validator.unique'),
            name: UNIQUE,
            valid,
        }];
}
UniqueValidator.optionTypes = {
    primaryKey: string,
};
export { UNIQUE, UniqueValidator, };
export default UniqueValidator;
//# sourceMappingURL=unique.js.map